module.exports = "<p>\r\n  {{data}}\r\n</p>\r\n"